import { Http409Code } from '@/api/model/HttpErrorCodes.model.ts';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { QueryParams } from '@/utils/QueryParam.enum.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import QuizExpiredMessageDesktop from '@/views/process/components/quizExpired/QuizExpiredMessageDesktop.tsx';
import QuizExpiredMessageMobile from '@/views/process/components/quizExpired/QuizExpiredMessageMobile.tsx';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Conflict409View: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBack = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(RoutesEnum.ROOT);
  };

  const errorCode = (searchParams.get(QueryParams.ERROR_CODE) ?? '409_2') as keyof typeof Http409Code;
  const isClosed = errorCode === '409_closed';

  return isMobile ? (
    <QuizExpiredMessageMobile
      errorCode={errorCode}
      handleBack={handleBack}
      hideBackButton={isClosed}
    />
  ) : (
    <QuizExpiredMessageDesktop
      errorCode={errorCode}
      handleBack={handleBack}
      hideBackButton={isClosed}
    />
  );
};

export default Conflict409View;
